import React, { useMemo } from 'react';
import moment from 'moment';
// @ts-ignore: TS2459 — we know it's there at runtime
import { DailyPerformanceCard } from '@PikaDoApp/pikado-web-dsm';
import { calculateDailyPerformanceGraphData } from './classReportCalculations/dailyPerformanceCalculations';

interface DailyPerformanceContainerProps {
  studentsDailyAveragesInClassThisMonth:any[],
  selectedMonth: string;
  onMonthChange: (month: string) => void;
  monthOptions: Array<{label: string; value: string}>;
}

export const DailyPerformanceContainer: React.FC<DailyPerformanceContainerProps> = ({
  studentsDailyAveragesInClassThisMonth,
  selectedMonth,
  onMonthChange,
  monthOptions,
}) => {

  const dailyPerformanceData = useMemo(() => {
    const dataMap = new Map<number, number>();

    if (studentsDailyAveragesInClassThisMonth && studentsDailyAveragesInClassThisMonth.length > 0) {
      studentsDailyAveragesInClassThisMonth.forEach((d: any) => {
        if (d.day) {
          // Ensure we only store valid, finite numbers
          const average = Number.isFinite(d.average) ? d.average : 0;
          dataMap.set(d.day, average);
        }
      });
    }

    // Generate all 31 days, filling missing days with 0
    const allDays = [];
    for (let day = 1; day <= 31; day++) {
      allDays.push({
        date: day.toString(),
        performance: dataMap.get(day) || 0,
      });
    }

    return allDays;
  }, [studentsDailyAveragesInClassThisMonth]);

  return (
    <DailyPerformanceCard
      dailyPerformanceData={dailyPerformanceData}
      title="Daily Performance "
      monthOptions={monthOptions}
      selectedMonth={selectedMonth}
      onMonthChange={onMonthChange}
    />
  );
};
